// src/editor/plugins/useTextColor.ts
import { $getSelection, createCommand, type LexicalEditor } from 'lexical';
import { applyStyle } from '../utils/applyStyle';

export const SET_TEXT_COLOR_COMMAND = createCommand<string>();
export const SET_HIGHLIGHT_COLOR_COMMAND = createCommand<string>();

export function registerTextColorCommands(editor: LexicalEditor): void {
    editor.registerCommand<string>(
        SET_TEXT_COLOR_COMMAND,
        (color: string) => {
            const selection = $getSelection();
            applyStyle(selection, 'color', color);
            return true;
        },
        0
    );

    editor.registerCommand<string>(
        SET_HIGHLIGHT_COLOR_COMMAND,
        (backgroundColor: string) => {
            const selection = $getSelection();
            applyStyle(selection, 'background-color', backgroundColor);
            return true;
        },
        0
    );
}
